import PAGES, { createURLPath } from "../pages";
import IdModel from "../models/HelperModels/IdModel";
import SearchQueryParams from "./SearchQueryParams";

export const pagePathGenerator = {
  HOME: () => PAGES.HOME,
  LOGIN_PAGE: () => {
    const currentPage = window.location.pathname + window.location.search + window.location.hash;
    const encoded = encodeURIComponent(currentPage);
    const props = {
      t: + new Date(),
      next: encoded,
    }
    return createURLPath({
      path: PAGES.LOGIN_PAGE,
      queryObject: props,
    })
  },
  USER_CREATE_PASSWORD_PAGE: () => PAGES.USER_CREATE_PASSWORD_PAGE,
  SETTINGS_PAGE: () => PAGES.SETTINGS_PAGE,
  REGIONS_AND_COUNTRY: (props: { regionId?: IdModel, countryId?: IdModel }) => {
    const { regionId, countryId } = props;
    return createURLPath({
      path: PAGES.REGIONS_AND_COUNTRY,
      queryObject: {
        regionId: regionId ? regionId : null,
        countryId: countryId ? countryId : null,
      }
    })
  },
  USER_MANAGEMENT: (filter?: 'all' | 'new' | 'activation' | 'active' | 'inactive') => {
    const path = {
      all: PAGES.USER_MANAGEMENT_ALL,
      'new': PAGES.USER_MANAGEMENT_NEW,
      activation: PAGES.USER_MANAGEMENT_ACTIVATION,
      active: PAGES.USER_MANAGEMENT_ACTIVE,
      inactive: PAGES.USER_MANAGEMENT_INACTIVE,
    }

    return filter ? path[filter] : PAGES.USER_MANAGEMENT;
  },
  WORKFLOW_MANAGEMENT: () => PAGES.WORKFLOW_MANAGEMENT,
  IMPORT: () => PAGES.IMPORT,
  GLOBAL_SETTINGS: () => PAGES.GLOBAL_SETTINGS,
  TECHNOLOGIES: () => PAGES.TECHNOLOGIES,
  REQUESTS: () => PAGES.REQUESTS,
  BUILDING_PAGE: (props: { locationId?: IdModel, buildingId?: IdModel, floorId?: IdModel }) => createURLPath({
    path: PAGES.BUILDINGS_PAGE,
    queryObject: props,
  }),
  LOCATION_PAGE: (props: { locationId?: IdModel, regionId?: IdModel, countryId?: IdModel }) => createURLPath({
    path: PAGES.LOCATIONS_PAGE,
    queryObject: props,
  }),
  FLOOR_MAP: (props: { floorId?: IdModel }) => createURLPath({
    path: PAGES.UPLOAD_MAP,
    queryObject: props,
  }),
  MAP_PAGE: (props: { floorId?: IdModel, locationId?: IdModel }) => createURLPath({
    path: PAGES.MAP_PAGE,
    queryObject: props,
  }),
  FREQUENCY_ANALYSIS: (props: { mapId?: IdModel }) => createURLPath({
    path: PAGES.FREQUENCY_ANALYSIS,
    queryObject: props,
  }),
  DEVICES_MAP: (props: { mapId?: IdModel; deviceId?: IdModel }) => createURLPath({
    path: PAGES.DEVICES_MAP,
    queryObject: props,
  }),
  SINGLE_DEVICE_PAGE: (props: { mapId?: IdModel, deviceId?: IdModel }) => createURLPath({
    path: PAGES.SINGLE_DEVICE_PAGE,
    queryObject: props,
  }),
  DEVICE_TEMPLATE_PAGE: (props: { countryId?: IdModel, templateId?: IdModel }) => createURLPath({
    path: PAGES.DEVICE_TEMPLATE_PAGE,
    queryObject: props,
  }),
  SEARCH_PAGE: (props: SearchQueryParams) => createURLPath({
    path: PAGES.SEARCH_PAGE,
    queryObject: props,
  }),
  BULK_EDIT_PAGE: (props: { deviceIdList?: number[] | null }) => createURLPath({
    path: PAGES.DEVICES_BULK_EDIT,
    queryObject: props,
  }),
  LICENCE_PAGE: (props: { licenceId?: number | null, locationId: number }) => createURLPath({
    path: PAGES.LICENCE_PAGE,
    queryObject: props,
  }),
}

export function redirectToLogin() {
  const url = pagePathGenerator.LOGIN_PAGE();

  if (window.location.pathname !== PAGES.LOGIN_PAGE) {
    window.location.href = window.location.protocol + '//' + window.location.host + url;
  }
}